import * as COMP from './images';

const movies = [
  { id: 0,
    name: 'Alerta Vermelho',
    image: COMP.alertavermelho,
    sinopse: 'No mundo do crime internacional, a INTERPOL lança um Alerta Vermelho, o que inicia uma caçada para capturar a mais notória ladra de artes do globo.',
    trailer: 'https://youtu.be/5JQuYpBZarc',
    imageCapa: COMP.alertavermelhocapa,
  },
  { id: 1,
    name: 'Não Olhe para Cima',
    image: COMP.naoolheparacima,
    sinopse: 'Dois astrônomos descobrem um cometa mortal vindo em direção à Terra e partem em um tour midiático para alertar a humanidade. Só que ninguém parece dar muita bola.',
    trailer: 'https://youtu.be/c1nToClX_3w',
    imageCapa: COMP.naoolheparacimacapa,
  },
  { id: 2,
    name: 'Imperdoável',
    image: COMP.imperdoavel,
    sinopse: 'Após cumprir pena por um crime violento, Ruth volta ao convívio na sociedade, que se recusa a perdoar seu passado. Discriminada no lugar que já chamou de lar, sua única esperança é encontrar a irmã, que ela havia sido forçada a deixar para trás.',
    trailer: 'https://youtu.be/P0RO1pF4L1o',
    imageCapa: COMP.imperdoavelcapa,
 },
  { id: 3,
    name: 'Homem-Aranha: De Volta ao Lar',
    image: COMP.homemaranha,
    sinopse: 'Depois de atuar ao lado dos Vingadores, chegou a hora do pequeno Peter Parker (Tom Holland) voltar para casa e para a sua vida, já não mais tão normal. Lutando diariamente contra pequenos crimes nas redondezas, ele pensa ter encontrado a missão de sua vida quando o terrível vilão Abutre (Michael Keaton) surge amedrontando a cidade. O problema é que a tarefa não será tão fácil como ele imaginava.',
    trailer: 'https://youtu.be/LBRrh_97QZI',
    imageCapa: COMP.homemaranhacapa,
 },
  { id: 4,
    name: 'Através da Minha Janela',
    image: COMP.atravesdaminhajanela,
    sinopse: 'Raquel é louca pelo vizinho Ares há muito tempo. Ela o observa de longe, mas nunca falou com ele. Será que vai dar match?',
    trailer: 'https://youtu.be/DB9-hN0s3r8',
    imageCapa: COMP.atravesdaminhajanelacapa,
  },
  { id: 5,
    name: 'Munique: No Limite da Guerra',
    image: COMP.nolimitedaguerra,
    sinopse: 'Na tensa Conferência de Munique em 1938, amigos que agora trabalham para governos opostos se tornam espiões e correm contra o tempo para revelar um segredo nazista.',
    trailer: 'https://youtu.be/8LJeGLu_2H0',
    imageCapa: COMP.nolimitedaguerracapa,
  },
  { id: 6,
    name: 'Enola Holmes',
    image: COMP.enolaholmes,
    sinopse: 'Enola Holmes só tem 16 anos, mas vai fazer de tudo para encontrar a mãe desaparecida, inclusive despistar o irmão Sherlock e ajudar um jovem lorde fugitivo.',
    trailer: 'https://youtu.be/rcV1I-397Wg',
    imageCapa: COMP.enolaholmescapa,
  },
  { id: 7,
    name: 'Escritores da Liberdade',
    image: COMP.ecritoresdaliberdade,
    sinopse: 'Uma jovem e idealista professora chega a uma escola de um bairro pobre, que está corrompida pela agressividade e violência. Os alunos se mostram rebeldes e sem vontade de aprender, e há entre eles uma constante tensão racial. Assim, para fazer com que os alunos aprendam e também falem mais de suas complicadas vidas, a professora Gruwell aposta em métodos diferentes de ensino. Aos poucos, os alunos vão retomando a confiança em si mesmos, aceitando mais o conhecimento e reconhecendo valores.',
    trailer: 'https://www.youtube.com/watch?v=pfwzLDj0yzM',
    imageCapa: COMP.escritoresdaliberdadecapa,
  },
  { id: 8,
    name: 'Exército de Ladrões: Invasão da Europa',
    image: COMP.exercitodeladroes,
    sinopse: 'Nesta história que antecede Army of the Dead, uma mulher misteriosa convida o caixa de banco Dieter para roubar cofres superprotegidos na Europa.',
    trailer: 'https://youtu.be/37dNU_rC6Gs',
    imageCapa: COMP.exercitodeladroescapa,
  },
  { id: 9,
    name: 'Justiça em Família',
    image: COMP.justiçaemfamilia,
    sinopse: 'Ele perdeu o amor de sua vida por causa da ganância da indústria farmacêutica. Agora, sua filha está órfã e a justiça não chega... por enquanto.',
    trailer: 'https://youtu.be/6dGXwuJzyas',
    imageCapa: COMP.justiçaemfamiliacapa,
  },
  { id: 10,
    name: 'O Preço do Amanhã',
    image: COMP.opreçodoamanha,
    sinopse: 'Acusado de assassinato, um homem deve descobrir como derrubar um sistema onde tempo é dinheiro e que permite que os ricos vivam para sempre, enquanto os pobres devem implorar por cada minuto de suas vidas.',
    trailer: 'https://youtu.be/XUSt9oZUTrs',
    imageCapa: COMP.opreçodoamanhacapa,
  },
  { id: 11,
    name: 'The House',
    image: COMP.thehouse,
    sinopse: 'Nesta comédia de animação de humor ácido, uma família humilde, um arquiteto ansioso e uma senhoria cansada ficam presos à mesma casa misteriosa em épocas diferentes.',
    trailer: 'https://www.youtube.com/watch?v=wqbZlAEUb5w',
    imageCapa: COMP.thehousecapa,
  },
  { id: 33,
    name: 'Ava',
    image: COMP.ava,
    sinopse: 'Atormentada por dúvidas, uma assassina de elite luta para proteger a si mesma e a sua família depois que uma missão dá errado.',
    trailer: 'https://youtu.be/Mot5ovqTPXo',
    imageCapa: COMP.avacapa,
  },
  { id: 34,
    name: 'Venom',
    image: COMP.venon,
    sinopse: 'O jornalista Eddie Brock desenvolve força e poder sobre-humanos quando seu corpo se funde com o alienígena Venom. Dominado pela raiva, Venom tenta controlar as novas e perigosas habilidades de Eddie.',
    trailer: 'https://youtu.be/NPsB0txsa7U',
    imageCapa: COMP.venoncapa,
  },
  { id: 35,
    name: 'Jurassic World: O Mundo dos Dinossauros',
    image: COMP.jword,
    sinopse: 'O Jurassic Park, localizado na ilha Nublar, enfim está aberto ao público. Com isso, as pessoas podem conferir shows acrobáticos com dinossauros e até mesmo fazer passeios bem perto deles, já que agora estão domesticados. Entretanto, a equipe chefiada pela doutora Claire passa a fazer experiências genéticas com estes seres, de forma a criar novas espécies. Uma delas adquire inteligência bem mais alta, logo se tornando uma grande ameaça para a existência humana.',
    trailer: 'https://youtu.be/S2_aWPGZwhs',
    imageCapa: COMP.jwordcapa,
  },
  { id: 36,
    name: 'Kate',
    image: COMP.kate,
    sinopse: 'Após ser envenenada de forma irreversível, uma assassina implacável tem menos de 24 horas para se vingar.',
    trailer: 'https://youtu.be/LtrS34nUGyQ',
    imageCapa: COMP.katecapa,
  },
  
];

export default movies;